import { AuthService } from '../services/auth/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminGuard } from './admin.guard';
import { ResumeGuard } from './resume.guard';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private admin: AdminGuard, private resume: ResumeGuard) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    if(this.admin.isAdmin() || this.resume.isResumeAdmin())
    {
      return true;
    } 
    else
    {
      //window.location.href = `/sign-in`;
      window.location.href = `/home`;
      return false;
    }

  }

}
